<app-cookie-banner />
<router-outlet />
<pwa-install
    manifest-url="/pwa/manifest.webmanifest"
    install-description="Install the app to enjoy a better gaming experience!"
></pwa-install>